import { render, staticRenderFns } from "./ImportStocks.vue?vue&type=template&id=830e4182&"
import script from "./ImportStocks.vue?vue&type=script&lang=js&"
export * from "./ImportStocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports